import CheckIsDDAvaliableModal from './CheckIsDDAvaliableModal'

export default CheckIsDDAvaliableModal
